export default function ConversationListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="divide-y divide-slate-100" data-testid="conversation-list-skeleton">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex items-center gap-3 p-4 animate-pulse">
          {/* Avatar skeleton */}
          <div className="w-14 h-14 rounded-full bg-slate-200 flex-shrink-0" />

          {/* Text rows skeleton */}
          <div className="flex-1 min-w-0 space-y-2">
            <div className="flex justify-between items-center">
              <div className="h-4 bg-slate-200 rounded w-1/3" />
              <div className="h-3 bg-slate-100 rounded w-10" />
            </div>
            <div className="flex justify-between items-center gap-2">
              <div className="h-3 bg-slate-100 rounded w-3/5" />
              <div className="h-4 bg-slate-200 rounded w-12 flex-shrink-0" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
